import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Descriptions, Drawer} from 'antd';

const MethodInfo = (props) => {
  const intl = useIntl();

  const {selectedMethod, viewing, setViewing} = props;

  const onClose = () => {
    setViewing(false);
  };

  return (
    <>
      <Drawer
        title={intl.messages['common.detail']}
        width={800}
        onClose={onClose}
        visible={viewing}
        destroyOnClose={true}
        bodyStyle={{paddingBottom: 80}}>
        <Descriptions
          bordered
          size='middle'
          style={{paddingTop: 10}}
          column={1}>
          <Descriptions.Item
            label={intl.messages['practitioner.method.treatment']}>
            {selectedMethod?.treatment}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['practitioner.method']}>
            {selectedMethod?.method}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.method.result']}>
            {selectedMethod?.result}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.method.description']}>
            {selectedMethod?.description}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
};

export default MethodInfo;

MethodInfo.propTypes = {
  selectedMethod: PropTypes.object,
  viewing: PropTypes.bool.isRequired,
  setViewing: PropTypes.func.isRequired,
};
